import { css as _css } from "@emotion/core";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Fragment } from 'react';
import without from 'lodash/without';
import PropTypes from 'prop-types';
import Recaptcha from 'react-google-invisible-recaptcha';
import { Checkbox } from '@domain-group/fe-blueprint-ui/form';
import { validEmail } from '@domain-group/fe-helper';
import { ProfileIcon, PhoneIcon, EmailIcon, PinIcon } from '@domain-group/fe-co-icon';
import { withSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button, Separator } from '@domain-group/fe-co-allhomes-design-system';
import { withAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { ContactField, CommentField, Promotion, AddressSelector, AgentList } from './components';
import sendEnquiry from './utils/send-enquiry';
import { appearancePropTypes, showSubheadings, isListingAppearance, isWatchlistAppearance, isAppraisalAppearance } from './utils/appearance';
import validatePhoneNumber from './utils/validate-phone-number';
import { container as promotionContainerStyle } from './components/promotion.style';
import styleFactory from './allhomes-enquiry-form.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var REQUIRED = '*';
var OPTIONAL = ' (optional)';
var OTHER = {
  id: 'OTHER',
  value: 'OTHER',
  label: 'Others'
};
class AllhomesEnquiryForm extends React.Component {
  constructor(props) {
    var _this$props$agencies, _this$props$agencies$, _this$props$agents;
    super(props);
    _defineProperty(this, "onCaptchaResolved", () => {
      this.doSend(_objectSpread(_objectSpread({}, this.getData()), {}, {
        token: this.recaptcha.getResponse(),
        reCaptchaType: 'invisible'
      }));
    });
    _defineProperty(this, "getFieldValue", key => this.state.contactFields[key].value);
    _defineProperty(this, "getData", () => _objectSpread(_objectSpread({}, this.state.formData), {}, {
      name: this.getFieldValue('name'),
      emailAddress: this.getFieldValue('email'),
      phone: this.getFieldValue('phone'),
      postcode: this.getFieldValue('postcode'),
      comments: this.state.comments,
      sendMeCopy: this.state.sendMeCopy,
      options: without([...this.state.reasons], OTHER.id),
      ua: navigator.userAgent
    }, isAppraisalAppearance(this.props.appearance) && {
      listingAddress: this.state.address
    }));
    _defineProperty(this, "shouldDisplayPromotion", () => {
      if (isListingAppearance(this.props.appearance) && this.props.sponsorship) {
        return true;
      }
      return false;
    });
    _defineProperty(this, "doSend", data => {
      this.props.sendEnquiry(this.props.endpointUrl, data).then(response => {
        if (response.emailHash) {
          this.props.sendEvent('send-enquiry', _objectSpread(_objectSpread({}, data), {}, {
            options: [...this.state.reasons]
          }));
          this.setState({
            wsResultText: 'Your enquiry is sent!'
          });
          if (this.props.onEnquirySent) {
            this.props.onEnquirySent(response.emailHash);
          }
          if (this.shouldDisplayPromotion()) {
            this.props.sendEvent('sponsorship-viewed');
          }
        }
      }).catch(() => {
        this.setState({
          wsResultText: 'Error connecting to server. Please try again later.',
          hasError: true
        });
      });
    });
    _defineProperty(this, "submitForm", () => {
      if (!this.validate()) {
        if (this.props.recaptchaSiteKey) {
          this.recaptcha.reset();
        }
        return;
      }
      if (this.props.recaptchaSiteKey) {
        this.recaptcha.execute();
      } else {
        this.doSend(this.getData());
      }
    });
    _defineProperty(this, "displayComment", () => {
      this.setState(prevState => ({
        displayComment: !this.props.enableMessage && prevState.reasons.has(OTHER.id)
      }));
    });
    _defineProperty(this, "isPromotionOrListingOrWatchlist", () => this.shouldDisplayPromotion() || isListingAppearance(this.props.appearance) || isWatchlistAppearance(this.props.appearance));
    _defineProperty(this, "displayHeader", () => ___EmotionJSX("div", {
      css: this.styles.header
    }, ___EmotionJSX("div", {
      css: this.styles.title
    }, this.state.wsResultText !== '' && this.isPromotionOrListingOrWatchlist() ? '' : this.props.formTitle)));
    _defineProperty(this, "displayLogo", () => this.props.logoUrl && ___EmotionJSX("div", {
      css: /*#__PURE__*/_css([this.styles.header])
    }, ___EmotionJSX("img", {
      src: this.props.logoUrl,
      alt: "",
      css: this.styles.logo
    })));
    _defineProperty(this, "validateField", (key, value) => {
      var field = this.contactFields[key];
      var error = field.required && !value > 0 ? field.requiredError : field.validate(value);
      var fieldState = {
        value,
        error: error || ''
      };
      return fieldState;
    });
    _defineProperty(this, "validate", () => {
      var newState = this.allFields.reduce((state, key) => _objectSpread(_objectSpread({}, state), {}, {
        [key]: this.validateField(key, this.state.contactFields[key].value)
      }), {});
      this.setState({
        contactFields: newState
      });
      return !Object.keys(newState).find(key => newState[key].error);
    });
    _defineProperty(this, "handleFieldChange", (key, value) => {
      var fieldState = this.validateField(key, value);
      this.setState(prevState => ({
        contactFields: _objectSpread(_objectSpread({}, prevState.contactFields), {}, {
          [key]: fieldState
        })
      }));
    });
    _defineProperty(this, "handleOptionChange", event => {
      if (event.target.checked) {
        this.state.reasons.add(event.target.value);
      } else {
        this.state.reasons.delete(event.target.value);
      }
      this.displayComment();
    });
    _defineProperty(this, "handleCommentChange", event => {
      this.setState({
        comments: event.target.value
      });
    });
    _defineProperty(this, "handleSendMeCopy", event => {
      this.setState({
        sendMeCopy: event.target.checked
      });
    });
    _defineProperty(this, "handleDone", () => {
      this.resetForm();
      this.props.onDoneClick();
    });
    _defineProperty(this, "resetForm", () => {
      this.setState({
        wsResultText: '',
        contactFields: this.allFields.reduce((fields, key) => _objectSpread(_objectSpread({}, fields), {}, {
          [key]: {
            value: '',
            error: ''
          }
        }), {}),
        comments: '',
        displayComment: false,
        disableSubmit: false,
        hasError: false
      });
    });
    _defineProperty(this, "renderCommentField", () => ___EmotionJSX(CommentField, {
      fieldValue: this.state.comments,
      onValueChange: this.handleCommentChange,
      placeholder: this.props.messagePlaceholder,
      appearance: this.props.appearance
    }));
    _defineProperty(this, "renderSendMeCopyField", () => ___EmotionJSX("div", {
      css: this.styles.sendCopyWrapper
    }, ___EmotionJSX(Checkbox, {
      name: "sendCopy",
      id: "COPY",
      onChange: this.handleSendMeCopy,
      labelContent: "Send me a copy of the enquiry",
      css: this.styles.checkbox
    })));
    _defineProperty(this, "updateDisableSubmit", disabled => {
      this.setState({
        disableSubmit: disabled
      });
    });
    _defineProperty(this, "updateFormData", formData => {
      this.setState({
        formData
      });
    });
    _defineProperty(this, "updateListingAddress", address => {
      this.setState({
        address
      });
    });
    _defineProperty(this, "agencies", (_this$props$agencies = this.props.agencies) === null || _this$props$agencies === void 0 ? void 0 : (_this$props$agencies$ = _this$props$agencies.filter(item => item.agency.isEmailContactable)) === null || _this$props$agencies$ === void 0 ? void 0 : _this$props$agencies$.slice(0, 2));
    _defineProperty(this, "agents", (_this$props$agents = this.props.agents) === null || _this$props$agents === void 0 ? void 0 : _this$props$agents.filter(item => item.agent.isEmailContactable));
    _defineProperty(this, "renderAppraisalSegment", () => ___EmotionJSX("div", {
      css: this.styles.addressAgents
    }, ___EmotionJSX(AddressSelector, {
      handleAddress: this.updateListingAddress,
      initialAddress: this.props.listingAddress
    }), ___EmotionJSX(AgentList, {
      type: this.props.formData.type,
      agencies: this.agencies,
      agents: this.agents,
      handleDisableSubmit: this.updateDisableSubmit,
      handleFormData: this.updateFormData
    })));
    _defineProperty(this, "renderFormContent", () => {
      var _this$agencies, _this$agents;
      return ___EmotionJSX(Fragment, null, (((_this$agencies = this.agencies) === null || _this$agencies === void 0 ? void 0 : _this$agencies.length) > 0 || ((_this$agents = this.agents) === null || _this$agents === void 0 ? void 0 : _this$agents.length) > 0) && this.renderAppraisalSegment(), ___EmotionJSX("div", {
        ref: _ref2 => {
          this.enquiryForm = _ref2;
        }
      }, !isAppraisalAppearance(this.props.appearance) && this.renderReasonCheckBoxes(), this.state.displayComment && this.renderCommentField(), showSubheadings(this.props.appearance) && ___EmotionJSX("div", {
        css: this.styles.sectionTitle
      }, "Your contact details"), this.renderContactFields(), this.props.enableMessage && this.renderCommentField(), this.props.enableSendMeCopy && this.renderSendMeCopyField(), ___EmotionJSX("div", {
        css: this.styles.separator
      }, ___EmotionJSX(Separator, null)), this.props.toggledFeatures[ToggledFeatureKey.AGENCY_BRANDING] && isAppraisalAppearance(this.props.appearance) && ___EmotionJSX("div", {
        css: this.styles.appraisalDisclaimer
      }, "By submitting an appraisal request, you agree that you have read and agree to our", ' ', ___EmotionJSX("a", {
        css: this.styles.disclaimerLink,
        href: "https://www.domain.com.au/group/privacy-policy/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "privacy policy"), "."), ___EmotionJSX("div", {
        css: this.styles.buttonGroup
      }, this.props.recaptchaSiteKey && ___EmotionJSX(Recaptcha, {
        ref: _ref => {
          this.recaptcha = _ref;
        },
        sitekey: this.props.recaptchaSiteKey,
        onResolved: this.onCaptchaResolved
      }), ___EmotionJSX(Button, {
        css: this.styles.button,
        onClick: this.submitForm,
        disabled: this.state.disableSubmit
      }, "Send Enquiry")), this.props.disclaimer && ___EmotionJSX("div", {
        css: this.styles.disclaimer
      }, this.props.disclaimer), this.props.recaptchaSiteKey && ___EmotionJSX("div", {
        css: this.styles.disclaimer
      }, "This site is protected by reCAPTCHA and the Google", ' ', ___EmotionJSX("a", {
        href: "https://policies.google.com/privacy"
      }, "Privacy Policy"), " and", ' ', ___EmotionJSX("a", {
        href: "https://policies.google.com/terms"
      }, "Terms of Service"), ' ', "apply.")));
    });
    _defineProperty(this, "renderContactField", key => {
      var field = this.contactFields[key];
      var fieldState = this.state.contactFields[key];
      return ___EmotionJSX(ContactField, {
        icon: field.icon,
        fieldName: key,
        placeHolder: "".concat(field.label).concat(field.required ? REQUIRED : OPTIONAL),
        onValueChange: event => this.handleFieldChange(key, event.target.value),
        fieldError: fieldState.error,
        fieldValue: fieldState.value,
        appearance: this.props.appearance
      });
    });
    _defineProperty(this, "renderContactFields", () => {
      var _this$styles = this.styles,
        table = _this$styles.table,
        row = _this$styles.row,
        leftCol = _this$styles.leftCol,
        rightCol = _this$styles.rightCol;
      return ___EmotionJSX("div", {
        css: table
      }, ___EmotionJSX("div", {
        css: row
      }, ___EmotionJSX("div", {
        css: leftCol
      }, this.renderContactField('name')), ___EmotionJSX("div", {
        css: rightCol
      }, this.renderContactField('phone'))), ___EmotionJSX("div", {
        css: row
      }, ___EmotionJSX("div", {
        css: leftCol
      }, this.renderContactField('email')), ___EmotionJSX("div", {
        css: rightCol
      }, this.renderContactField('postcode'))));
    });
    _defineProperty(this, "renderFormSubmitResult", () => ___EmotionJSX("div", {
      css: this.styles.successMessageContainer
    }, this.isPromotionOrListingOrWatchlist() && !this.state.hasError ? ___EmotionJSX(Fragment, null, ___EmotionJSX("div", {
      css: this.styles.promotionSuccessMessage
    }, "Thank you for your interest in\xA0", ___EmotionJSX("span", {
      css: this.styles.address
    }, this.props.listingAddress), ", your enquiry has now been sent to the agent."), ___EmotionJSX("div", {
      css: this.styles.promotionResetButtonGroup
    }, ___EmotionJSX(Button, {
      css: this.styles.resetButton,
      appearance: "outline",
      onClick: this.handleDone
    }, this.props.doneText))) : ___EmotionJSX(Fragment, null, ___EmotionJSX("div", {
      css: this.styles.successMessage
    }, this.state.wsResultText), ___EmotionJSX("div", {
      css: this.styles.resetButtonGroup
    }, ___EmotionJSX(Button, {
      css: this.styles.resetButton,
      appearance: "outline",
      onClick: this.handleDone
    }, this.props.doneText)))));
    _defineProperty(this, "renderReasonCheckBoxes", () => {
      var checkboxes = this.props.options.map(option => ___EmotionJSX("li", {
        key: option.id
      }, ___EmotionJSX(Checkbox, {
        name: option.value,
        id: option.id,
        value: option.value,
        onChange: this.handleOptionChange,
        labelContent: option.label,
        css: this.styles.checkbox,
        checked: this.state.reasons.has(option.value)
      })));
      return ___EmotionJSX("div", null, showSubheadings(this.props.appearance) && ___EmotionJSX("div", {
        css: this.styles.sectionTitle
      }, "What would you like to enquire about?"), ___EmotionJSX("ul", {
        css: this.styles.checkboxColumns
      }, checkboxes, this.props.enableOther && ___EmotionJSX("li", {
        key: OTHER.id
      }, ___EmotionJSX(Checkbox, {
        name: OTHER.value,
        id: OTHER.id,
        value: OTHER.value,
        onChange: this.handleOptionChange,
        labelContent: OTHER.label,
        css: this.styles.checkbox
      }))));
    });
    this.contactFields = {
      name: {
        label: 'Full Name',
        icon: ProfileIcon,
        required: true,
        requiredError: 'Please enter your full name',
        validate: () => {}
      },
      phone: {
        label: 'Phone Number',
        icon: PhoneIcon,
        required: props.requirePhonenumber,
        requiredError: 'Please enter your phone number',
        validate: value => !validatePhoneNumber(value) && 'Please enter a valid phone number'
      },
      email: {
        label: 'Email',
        icon: EmailIcon,
        required: true,
        requiredError: 'Please enter your email address',
        validate: value => validEmail(value) ? '' : 'Invalid email address'
      },
      postcode: {
        label: 'Postcode',
        icon: PinIcon,
        required: true,
        requiredError: 'Please enter postcode',
        validate: value => /^\d{4}$/.test(value) ? '' : 'Invalid postcode'
      }
    };
    this.allFields = Object.keys(this.contactFields);
    this.state = {
      contactFields: this.allFields.reduce((fields, key) => _objectSpread(_objectSpread({}, fields), {}, {
        [key]: {
          value: '',
          error: ''
        }
      }), {}),
      wsResultText: '',
      reasons: new Set(this.props.checkedOptions),
      comments: '',
      displayComment: false,
      sendMeCopy: false,
      disableSubmit: false,
      formData: this.props.formData,
      address: this.props.listingAddress,
      hasError: false
    };
    this.enquiryForm = {};
    this.styles = styleFactory(this.props.appearance);
  }
  componentDidMount() {
    var elements = this.enquiryForm.elements ? this.enquiryForm.elements : null;
    if (elements) {
      Object.keys(elements).forEach(index => {
        elements[index].tabIndex = 0;
      });
    }
  }
  render() {
    return ___EmotionJSX("section", {
      css: this.styles.enquiryForm
    }, ___EmotionJSX("div", {
      css: this.styles.container
    }, this.displayLogo(), this.displayHeader(), this.state.wsResultText === '' ? this.renderFormContent() : this.renderFormSubmitResult()), !this.shouldDisplayPromotion() && isListingAppearance(this.props.appearance) && this.state.wsResultText !== '' && ___EmotionJSX("div", {
      css: promotionContainerStyle(undefined)
    }), this.shouldDisplayPromotion() && this.state.wsResultText !== '' && ___EmotionJSX(Promotion, this.props.sponsorship.enquirySection));
  }
}
AllhomesEnquiryForm.propTypes = {
  appearance: appearancePropTypes.isRequired,
  endpointUrl: PropTypes.string.isRequired,
  recaptchaSiteKey: PropTypes.string,
  formTitle: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  disclaimer: PropTypes.string,
  doneText: PropTypes.string,
  messagePlaceholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })),
  enableOther: PropTypes.bool,
  enableSendMeCopy: PropTypes.bool,
  enableMessage: PropTypes.bool,
  requirePhonenumber: PropTypes.bool,
  formData: PropTypes.shape({
    agencyId: PropTypes.number,
    ids: PropTypes.arrayOf({
      id: PropTypes.number
    }),
    type: PropTypes.string
  }),
  sendEnquiry: PropTypes.func,
  onEnquirySent: PropTypes.func,
  onDoneClick: PropTypes.func,
  sendEvent: PropTypes.func,
  listingAddress: PropTypes.string,
  sponsorship: PropTypes.shape({
    enquirySection: PropTypes.shape({})
  }),
  agencies: PropTypes.arrayOf({
    agency: PropTypes.shape({})
  }),
  agents: PropTypes.arrayOf({
    agent: PropTypes.shape({})
  }),
  checkedOptions: PropTypes.arrayOf(PropTypes.string),
  toggledFeatures: PropTypes.shape({
    [ToggledFeatureKey.AGENCY_BRANDING]: PropTypes.bool
  })
};
AllhomesEnquiryForm.defaultProps = {
  logoUrl: null,
  onEnquirySent: () => {},
  recaptchaSiteKey: '',
  disclaimer: null,
  requirePhonenumber: false,
  onDoneClick: () => {},
  options: [],
  doneText: 'Reset form',
  messagePlaceholder: 'Message',
  enableMessage: false,
  enableSendMeCopy: false,
  enableOther: false,
  sendEnquiry,
  formData: {},
  sendEvent: () => {},
  listingAddress: '',
  sponsorship: {},
  agencies: [],
  agents: [],
  checkedOptions: [],
  toggledFeatures: {}
};
export { AllhomesEnquiryForm as BaseAllhomesEnquiryForm };
export default withAllhomesApi('toggledFeatures')(withSendEvent(AllhomesEnquiryForm));